module.exports = [{"type":"title","text":"2024-10-11"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USDT Websocket Service: 'Order update push' add 'ro' field('reduceOnly' field)."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-10-11.json
// module id = McI3
// module chunks = 3